import useTheme from '@hooks/useTheme';
import { injectTestId } from '@cvent/nucleus-test-automation';
import React from 'react';
import PropTypes from 'prop-types';
import { keyframes } from '@emotion/react';

const useStyles = theme => {
  const {
    size,
    borderColor,
    animation,
    backgroundColor: { neutral }
  } = theme;
  const load = keyframes`
    from {
      left: -200px;
    }
    to {
      left: 100%
    }
  `;
  const middleContainer = {
    height: '17px',
    backgroundColor: neutral.disabled,
    overflow: 'hidden',
    position: 'relative',
    borderRadius: size.border.radius.fiveX,
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: '-200px',
      top: 0,
      height: '100%',
      width: '200px',
      background: `linear-gradient(277deg, ${neutral.disabled} 0% 20%, ${neutral.fill.disabled} 40% 60%, ${neutral.disabled} 80% 100%)`,
      animation: `${load} 2s ${animation.expressive.easeInOut.easing} infinite`
    }
  };
  return {
    loadingLeftContainer: {
      width: '6%',
      position: 'relative'
    },
    loadingLeft: {
      width: '10px',
      height: '10px',
      backgroundColor: '#f1f1f1',
      borderRadius: size.border.radius.fiveX,
      position: 'absolute',
      top: '40%'
    },
    loadingParentContainer: {
      height: '108px',
      display: 'flex',
      flexDirection: 'row',
      padding: '24px',
      borderBottom: `${size.border.base}px solid ${borderColor.soft}`
    },
    loadingMiddleContainer: {
      width: '74%'
    },

    middleContainerFirst: {
      width: '276px',
      ...middleContainer
    },
    middleContainerSecond: {
      width: '191px',
      marginTop: '5px',
      ...middleContainer
    },
    middleContainerThird: {
      width: '88px',
      marginTop: '5px',
      ...middleContainer
    },
    loadingRightContainer: {
      position: 'relative',
      width: '20%'
    },
    loadingRightContent: {
      width: '80px',
      position: 'absolute',
      top: '40%',
      ...middleContainer
    }
  };
};

/**
 * Component for rendering loading screen if notifications are loading
 */
const NotificationsLoading = props => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const { testID } = props;
  return (
    <div
      css={styles.loadingParentContainer}
      {...injectTestId(`${testID}-container`)}
    >
      <div css={styles.loadingLeftContainer}>
        <div css={styles.loadingLeft}></div>
      </div>
      <div css={styles.loadingMiddleContainer}>
        <div css={styles.middleContainerFirst}></div>
        <div css={styles.middleContainerSecond}></div>
        <div css={styles.middleContainerThird}></div>
      </div>
      <div css={styles.loadingRightContainer}>
        <div css={styles.loadingRightContent}></div>
      </div>
    </div>
  );
};

NotificationsLoading.propTypes = {
  testID: PropTypes.string
};

export default NotificationsLoading;
